import { Storyteller } from '@forchange/storytime';

const WORLD_PREFIX = 'localWorld';
const WORLD_ABSTRACT_PREFIX = 'localAbstractWorld';
const PORTAL_PREFIX = 'locaProtal';
const REVIEW_SURVEY = 'reviewSurvey';

class Local {
  static setLocal(prefix: string, version: string, key: string, data: string): void {
    window.localStorage.setItem(`${prefix}:${version}:${key}`, data);
  }

  static getLocal(prefix: string, version: string, key: string) {
    return window.localStorage.getItem(`${prefix}:${version}:${key}`);
  }

  static removeLocal(prefix: string, version: string, key: string) {
    window.localStorage.removeItem(`${prefix}:${version}:${key}`);
  }

  static removeItem(item: string) {
    window.localStorage.removeItem(item);
  }
}

// storyTime local
function setLocalWorld(version: string, key: string, storyteller: Storyteller): void {
  const text = JSON.stringify(storyteller.toJson());
  Local.setLocal(WORLD_PREFIX, version, key, text);
}

function getLocalWorld(version: string, key: string): string | null {
  return Local.getLocal(WORLD_PREFIX, version, key);
}

function removeLocalWorld(version: string, key: string): void {
  Local.removeLocal(WORLD_PREFIX, version, key);
}

function removeAllLocalWorld(exclude?: string) {
  Object.keys(localStorage).forEach((localKey) => {
    if (localKey.startsWith(WORLD_PREFIX) && localKey !== `${WORLD_PREFIX}:${exclude}`) {
      Local.removeItem(localKey);
    }
  });
}

// portal sequence stack
function setLocalPortal(version: string, key: string, stack: string) {
  Local.setLocal(PORTAL_PREFIX, version, key, stack);
}

function getLocalPortal(version: string, key: string): string | null {
  return Local.getLocal(PORTAL_PREFIX, version, key);
}

function removeLocalPortal(version: string, key: string): void {
  Local.removeLocal(PORTAL_PREFIX, version, key);
}

function removeAllLocalPortal(exclude?: string) {
  Object.keys(localStorage).forEach((localKey) => {
    if (localKey.startsWith(PORTAL_PREFIX) && localKey !== `${PORTAL_PREFIX}:${exclude}`) {
      Local.removeItem(localKey);
    }
  });
}

// abstract world or history
function setLocalAbstractWorld(version: string, key: string, abstractWorld: string): void {
  Local.setLocal(WORLD_ABSTRACT_PREFIX, version, key, abstractWorld);
}

function getLocalAbstractWorld(version: string, key: string): string | null {
  return Local.getLocal(WORLD_ABSTRACT_PREFIX, version, key);
}

function removeLocalAbstractWorld(version: string, key: string): void {
  Local.removeLocal(WORLD_ABSTRACT_PREFIX, version, key);
}

function removeAllLocalAbstractWorld(key: string) {
  Object.keys(localStorage).forEach((localKey) => {
    if (localKey.startsWith(WORLD_ABSTRACT_PREFIX) && localKey.indexOf(key) > 0) {
      Local.removeItem(localKey);
    }
  });
}

// review survey data
function setReviewSurvey(version: string, key: string, abstractWorld: string): void {
  Local.setLocal(REVIEW_SURVEY, version, key, abstractWorld);
}

function getReviewSurvey(version: string, key: string): string | null {
  return Local.getLocal(REVIEW_SURVEY, version, key);
}

function removeLocalReviewSurvey(version: string, key: string): void {
  Local.removeLocal(REVIEW_SURVEY, version, key);
}

function removeAllLocalReviewSurvey(key: string) {
  Object.keys(localStorage).forEach((localKey) => {
    if (localKey.startsWith(REVIEW_SURVEY) && localKey.indexOf(key) > 0) {
      Local.removeItem(localKey);
    }
  });
}

export {
  // old local
  setLocalWorld,
  getLocalWorld,
  removeLocalWorld,
  removeAllLocalWorld,
  // portal
  setLocalPortal,
  getLocalPortal,
  removeLocalPortal,
  removeAllLocalPortal,
  // abstract local
  setLocalAbstractWorld,
  getLocalAbstractWorld,
  removeLocalAbstractWorld,
  removeAllLocalAbstractWorld,
  // review survey
  setReviewSurvey,
  getReviewSurvey,
  removeLocalReviewSurvey,
  removeAllLocalReviewSurvey
};
